module.exports = __webpack_public_path__ + "img/zhendeen.6ec05765.jpg";